export const MuiFormLabel = (palette) => {
    return {
        root: {
            color: palette.semantic.colorForeground,
            '&.Mui-disabled': { color: palette.semantic.colorForegroundDisable },
        },
    };
};
